import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['basketItems']),
    numBasketItems () {
      let total = parseInt(0, 10)
      for (var shopId in this.basketItems) {
        if (Object.prototype.hasOwnProperty.call(this.basketItems, shopId)) {
          let items = this.basketItems[shopId] || []
          for (var i = 0; i < items.length; i++) {
            if (!items[i] || items[i].id === 0 || items[i].id === '0') {
              continue
            }
            if (items[i].reservation_desc === null) {
              total += Math.abs(parseFloat(items[i].count) || 0)
            } else {
              total++
            }
          }
        }
      }
      return total
    }
  }
}
